import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { HomeRoutingModule } from './home-routing.module';

// import { AgmCoreModule } from '@agm/core';
// import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { NgxPayPalModule } from 'ngx-paypal';
import { HomeComponent } from './home/home.component';
import { Home1Component } from './home1/home1.component';

// Widgest Components
import { SliderComponent } from './widgets/slider/slider.component';
import { BlogComponent } from './widgets/blog/blog.component';
import { LogoComponent } from './widgets/logo/logo.component';
import { InstagramComponent } from './widgets/instagram/instagram.component';
import { ServicesComponent } from './widgets/services/services.component';
import { CollectionComponent } from './widgets/collection/collection.component';

import { RestDeliveryComponent } from './rest-delivery/rest-delivery.component';

import { RestTakeawayComponent } from './rest-takeaway/rest-takeaway.component';
import { DomicilioComponent } from './domicilio/domicilio.component';

import { DashboardComponent } from '../pages/account/dashboard/dashboard.component';
import { LoginComponent } from '../pages/account/login/login.component';
import { ProfileComponent } from '../pages/account/profile/profile.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CartComponent } from './cart/cart.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { CheckComponent } from './check/check.component';
import { SuccessComponent } from './checkout/success/success.component';
import { CheckpayComponent } from './checkpay/checkpay.component';
import { CardpayComponent } from './cardpay/cardpay.component';
import { CashpayComponent } from './cashpay/cashpay.component';
import { PaypalpayComponent } from './paypalpay/paypalpay.component';
import { SatispaypayComponent } from './satispaypay/satispaypay.component';
import { CardpaykoComponent } from './cardpayko/cardpayko.component';
import { CardpayokComponent } from './cardpayok/cardpayok.component';
import { RestaurantViewComponent } from './restaurant-view/restaurant-view.component';

@NgModule({
  declarations: [ 
    HomeComponent,
    Home1Component,
    CartComponent,
    CardpayComponent,
    CardpayokComponent,
    CardpaykoComponent,
    CashpayComponent,
    SatispaypayComponent,
    PaypalpayComponent,
    CheckoutComponent,
    CheckpayComponent,
    CheckComponent,
    SuccessComponent,
    SliderComponent,
    BlogComponent,
    LogoComponent,
    InstagramComponent,
    ServicesComponent,
    CollectionComponent,
    RestDeliveryComponent,
    RestTakeawayComponent,
    DashboardComponent,
    LoginComponent,
    ProfileComponent,
    DomicilioComponent,
    RestaurantViewComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    /* AgmCoreModule.forRoot({
      apiKey: 'AIzaSyB7zPHj0X2lXw3C4d8LHB4cbMSC1nGrgjg', 
      libraries: ['places'],
      region: "IT",
      language: "IT"
    }), */
    // GooglePlaceModule,
    NgxPayPalModule,
    InfiniteScrollModule,
    SharedModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomeModule { }
